import { createEnumGuard } from '#/utils/typeGuards'

export const ANNOUNCEMENT_VARIANTS = ['info', 'warning', 'critical'] as const
export type TAnnouncementVariant = (typeof ANNOUNCEMENT_VARIANTS)[number]
export const isAnnouncementVariant = createEnumGuard(ANNOUNCEMENT_VARIANTS)

export const ANNOUNCEMENT_STATUSES = ['scheduled', 'live', 'ended'] as const
export type TAnnouncementStatus = (typeof ANNOUNCEMENT_STATUSES)[number]
export const isAnnouncementStatus = createEnumGuard(ANNOUNCEMENT_STATUSES)

export interface IAnnouncement {
  id: string
  message: string
  variant: TAnnouncementVariant
  status: TAnnouncementStatus
  companyId: string | null
  companyName: string | null
  startsAt: string
  endsAt: string
  createdByName: string | null
  createdAt: string
  updatedAt: string
}

export interface IActiveAnnouncement {
  id: string
  message: string
  variant: TAnnouncementVariant
}
